define('shared/util/tracking/pendingEvents',[
        '$',
        'shared/lib/RSVP',
        'shared/lib/console',
        'shared/initializer/form/constants',
        'shared/util/state',
        'shared/util/state/adapters/pending'
    ],
    function(
        $,
        RSVP,
        console,
        constants,
        state,
        pendingAdapter){

    'use strict';

    return {
        add: function(toBeAdded){
            if(!toBeAdded){
                return RSVP.resolved();
            }

            var events = [];

            return state.adapters
                .add(pendingAdapter)
                .then(function(){
                    return state.get(constants.State.TrackingPendingEvents);
                })
                .then(function(values){
                    events = values[0] || [];
                    events.push(toBeAdded);
                    return state.push(constants.State.TrackingPendingEvents, events);
                });
        }
    };
});
